import { Inject, Pipe, PipeTransform } from 'ng-metadata/core'


/**
 * @ngdoc filter
 * @name mwTruncateNumber
 * @module mw.components.dataFormatting
 *
 * @param {number} [input] - Number to be truncated
 * @returns {string} a new string representation of the truncated number
 *
 * @description
 * `mw-truncate-number` transforms large numbers into easy to read localized string
 */
@Pipe({
    name: 'mwTruncateNumber',
    pure: false
})
export class TruncateNumberPipe implements PipeTransform {
    private numberPipe;
    private BaseNumbers = {
        E: 1000000000000000000, // quintillion
        Q: 1000000000000000, // quadrillion, standard symbol is 'P'
        T: 1000000000000, // trillion
        B: 1000000000, // billion, standard symbol is 'G'
        M: 1000000, // million
        k: 1000, // thousand
        '': 1
    }

    constructor(@Inject('$filter') private $filter: ng.IFilterService) {
        this.numberPipe = $filter('number');
    }

    transform(input: number): string {
        let roundedInput: number = Math.round(input);
        let truncatedNumber: number;
        let fixedNumber: String;
        let numberKey: String = '';
        let dotIndex: Number;

        if (input === null || isNaN(roundedInput)) {
            return '-'
        }

        if (roundedInput === 0 || roundedInput === -0) {
            return '0';
        }

        if (Math.abs(roundedInput) >= this.BaseNumbers.E) {
            return this.numberPipe(roundedInput)
        }

        for (let key of Object.keys(this.BaseNumbers)) {
            if (Math.abs(roundedInput) >= this.BaseNumbers[key]) {
                truncatedNumber = roundedInput / this.BaseNumbers[key];
                numberKey = key;
                break;
            }
        }

        dotIndex = Math.abs(truncatedNumber).toString().indexOf('.');

        if (dotIndex === 1) {
            fixedNumber = truncatedNumber.toFixed(2);
        } else if (dotIndex === 2) {
            fixedNumber = truncatedNumber.toFixed(1);
        } else {
            fixedNumber = truncatedNumber.toFixed(0);
        }

        // localize the number via angular number pipe and append number key before returning
        return this.numberPipe(fixedNumber) + numberKey;
    }
}



// WEBPACK FOOTER //
// ./src/lib/components/data-formatting/truncate-number.pipe.ts